import { LIMIT_INITIAL_VALUE, PAGE_INITIAL_VALUE } from 'common/constants';
import { IProduct, IProductsFilter, IProductState } from './types';

export const productInitialState: IProduct = {
  id: '',
  storePrice: 0,
  available: false,
  linxPrice: 0,
  sku: {
    product: {
      id: '',
      name: '',
      discount: 0,
    },
    image: {
      marketingUrl: '',
    },
    color: {
      name: '',
    },
    id: '',
    lmi: 0,
    storage: 0,
    basePrice: 0,
    maxPercentage: 0,
    maxPercentageAccessories: 0,
    maxPercentageInsurance: 0,
    maxPrice: 0,
  },
};

export const productsFilterInitialState: IProductsFilter = {
  page: PAGE_INITIAL_VALUE,
  limit: LIMIT_INITIAL_VALUE,
  available: null,
  model: '',
};

export const productsInitialState: IProductState = {
  products: { items: [productInitialState], count: 0 },
  productSelected: productInitialState,
  productsFilter: productsFilterInitialState,
  groupProducts: { items: [], count: 0 },
  groupProductSelected: { sku: productInitialState.sku, availability: false, price: 0 },
  sku: { items: [productInitialState.sku], count: 0 },
  skuSelected: productInitialState.sku,
};
